import { render, staticRenderFns } from "./BagFilter.vue?vue&type=template&id=4616a16d&"
import script from "./BagFilter.vue?vue&type=script&lang=js&"
export * from "./BagFilter.vue?vue&type=script&lang=js&"
import style0 from "./BagFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports